import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext.tsx";
import { trackEvent } from "../utils/analytics.ts";

const AnalyticsTracker: React.FC = () => {
  const location = useLocation();
  const { currentUser, loading } = useAuth();
  const authInitialized = useRef(false);

  useEffect(() => {
    trackEvent("page_view", {
      page_path: `${location.pathname}${location.search}`,
      page_title: document.title,
    });
  }, [location.pathname, location.search]);

  useEffect(() => {
    if (loading) return;

    if (authInitialized.current && currentUser) {
      trackEvent("login", { method: "firebase" });
    }

    authInitialized.current = true;
  }, [currentUser, loading]);

  return null;
};

export default AnalyticsTracker;
